import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import getMatched from './getMatched';

class Routes extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  state = getMatched(this.props.location.pathname);

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(getMatched(nextProps.location.pathname));
  }

  render() {
    const { location } = this.props;
    const { route, match } = this.state;

    if (!route) {
      throw new Error('Route is not matched!');
    }

    return <route.component location={location} match={match} />;
  }
}

export default withRouter(Routes);
